import React from 'react';
import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/process.home.actions';

import Instance from './Instance';
import PanelInfo from '../../labels/PanelInfo';

class Index extends React.Component {
    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    render() {
        const { param, params } = this.props;
        return (
            <div className={'flex_full_row bg_ice_blue'}>
                <div
                    className={'flex_50 overflow_y_scroll padding_top_12 shadow_right_only showbar'}
                    onScroll={this.handleScroll}
                >
                    <Instance param={param} params={params} />
                </div>
                <PanelInfo is50={true} id={'instance_aux_message'} />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}
Index = connect(
    null,
    mapDispatchToProps,
)(Index);

export default Index;



// WEBPACK FOOTER //
// ./src/components/complex/instances/Index.js